import ComboBox from './combo-box.js';
import {search} from '../helpers/ajax.js';
import debounce from '../helpers/debounce.js';

class CourseSearch extends ComboBox {
    constructor() {
        super();
        this.addEventListener('focusin', this.onFocusIn, {once: true});
        this.addEventListener('input', debounce(this.onInput));
    }

    /**
     * @param {string} query
     */
    fill(query) {
        this.input.focus();
        this.input.value = query.trim();
        this.suggest();
    }

    async suggest() {
        const query = this.input.value.trim();
        try {
            this.menu.innerHTML = await search(query);
            this.menu.selectedOption = null;
            this.menu.show();
            this.menu.scroll(0, 0);
        } catch {
            this.menu.innerHTML = '';
            this.menu.hidden = !query.length;
        }
    }

    onFocusIn() {
        if (this.dataset.reachGoal) {
            ym(77836015, 'reachGoal', this.dataset.reachGoal);
        }
    }

    onInput() {
        this.suggest();
    }
}

customElements.define('course-search', CourseSearch);
export default CourseSearch;
